import { Photos } from '@frontend/photos';
import { Text, useTooltip } from '@frontend/design-system';

type PaymentsListContactNameProps = {
  id: string;
  /**
   * The invoice knows what location ID it is from. Must be passed down. Already a prop in Photos.ContactProfilePhoto.
   */
  locationId?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
};

export const PaymentsListContactName = ({
  id,
  name,
  firstName: propFirstName,
  lastName: propLastName,
  locationId,
}: PaymentsListContactNameProps) => {
  // If firstName and lastName are provided, use them directly
  // Otherwise, split the full name
  const displayFirstName = propFirstName || (name ? name.split(' ')[0] : '');
  const displayLastName = propLastName || (name ? name.split(' ').slice(1).join(' ') : '');

  const fullName = name || (propFirstName && propLastName ? `${propFirstName} ${propLastName}` : '');
  const { Tooltip: NameTooltip, tooltipProps, triggerProps } = useTooltip({ placement: 'bottom', hoverDelay: 300 });

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
      }}
    >
      <Photos.ContactProfilePhoto name={name} personId={id} locationId={locationId} size='small' />
      <div
        css={[
          {
            display: 'flex',
            gap: 4,
            minWidth: 0,
            overflow: 'hidden',
          },
        ]}
        {...triggerProps}
      >
        <Text weight='bold'>{displayFirstName}</Text>
        {displayLastName && (
          <Text
            css={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {' '}
            {displayLastName}
          </Text>
        )}
      </div>
      {fullName && <NameTooltip {...tooltipProps}>{fullName}</NameTooltip>}
    </div>
  );
};
